


























import { defineComponent, ref, onMounted } from 'vue';
import type {
  Onset, Pixel, Rect, Signature, Source,
} from '@/data';
import PixelUtils from '@/data/PixelUtils';

export default defineComponent({
  name: 'CanvasSourceGrid',
  props: {
    source: {
      type: Object as () => Source,
      required: true,
    },
    signature: {
      type: Object as () => Signature,
      required: true,
    },
  },
  setup(props) {
    const rects = ref<Rect[]>([]);

    onMounted(() => {
      const { pixelUnit } = props.source;

      if (props.source.pages) {
        for (let j = 0; j < props.source.pages.length; j += 1) {
          const rows = props.source.pages[j]?.rows;
          if (rows && rows.length) {
            for (
              let m = 0; // TODO: get measure of this page #723
              m <= props.signature.getMeasureNumber();
              m += 1
            ) {
              const i = props.signature.getOnsetFromMeasure(m);
              const dur = props.signature.getMeasureDuration();

              const startPixel = PixelUtils.deMux(pixelUnit.fromOnset(i + 0.01 as Onset).value);
              const endPixel = PixelUtils.deMux(pixelUnit.fromOnset(i + dur as Onset).value);
              const width = endPixel.x - startPixel.x as Pixel;

              let x: Pixel;
              if (endPixel.row !== startPixel.row || endPixel.page !== startPixel.page) {
                x = endPixel.x - width as Pixel;
              } else {
                x = startPixel.x;
              }

              // Pas générique, ne prend pas la hauteur de chaque page
              const y = (startPixel.row * rows[0].height)
                + (startPixel.page * props.source.pages[j].height) as Pixel;

              rects.value.push({
                x,
                y,
                width,
                height: rows[0].height as Pixel,
              });
            }
          }
        }
      }
    });

    return {
      rects,
    };
  },
});
